<template>
  <div class="broadband-order">
    <div class="page-bg"></div>
    <section class="hero">
      <div class="hero__content">
        <div class="hero__topline">
          <span class="brand-mark">CT</span>
          <span>山东电信</span>
        </div>
        <h1>山东电信宽带全能办</h1>
        <p>线上提交资料，专员外呼确认，电信装维上门安装。</p>
        <div class="hero-card">
          <div>
            <span>办理流程</span>
            <strong>全程专员跟进</strong>
          </div>
          <van-icon name="service-o" />
        </div>
      </div>
      <div class="process">
        <div class="process__item">
          <span>01</span>
          <strong>提交订单</strong>
        </div>
        <div class="process__line"></div>
        <div class="process__item">
          <span>02</span>
          <strong>外呼确认</strong>
        </div>
        <div class="process__line"></div>
        <div class="process__item">
          <span>03</span>
          <strong>电信维修上门安装</strong>
        </div>
      </div>
    </section>

    <section class="benefits">
      <div class="benefit-item">
        <van-icon name="certificate" />
        <span>电信受理</span>
      </div>
      <div class="benefit-item">
        <van-icon name="phone-o" />
        <span>外呼核验</span>
      </div>
      <div class="benefit-item">
        <van-icon name="wap-home-o" />
        <span>装维上门</span>
      </div>
    </section>

    <section class="panel offer-panel">
      <div class="section-title">
        <span><van-icon name="points" />宽带套餐</span>
        <em>{{ selectedOffer.offerNbr }}</em>
      </div>
      <div class="offer-display">
        <div>
          <span class="offer-label">当前选择</span>
          <strong>{{ selectedOffer.offerName }}</strong>
        </div>
        <button type="button" @click="showOfferPicker = true">切换</button>
      </div>
      <van-field
        readonly
        clickable
        label="选择套餐"
        :value="selectedOfferText"
        placeholder="请选择宽带套餐"
        right-icon="arrow"
        @click="showOfferPicker = true"
      />
      <div class="offer-summary">
        <span>{{ selectedOffer.speed || '宽带' }}</span>
        <span>{{ selectedOffer.period || '全能办' }}</span>
        <span v-if="selectedOffer.price">{{ selectedOffer.price }}元</span>
        <span v-else>专属套餐</span>
      </div>
    </section>

    <div v-if="showOfferPicker" class="offer-modal">
      <div class="offer-modal__mask" @click="showOfferPicker = false"></div>
      <div class="offer-modal__panel">
        <div class="offer-modal__header">
          <strong>选择宽带套餐</strong>
          <button type="button" @click="showOfferPicker = false">
            <van-icon name="cross" />
          </button>
        </div>
        <div class="offer-options">
          <button
            v-for="item in offerList"
            :key="item.offerNbr"
            type="button"
            class="offer-option"
            :class="{ active: form.offerNbr === item.offerNbr }"
            @click="onOfferConfirm(item)"
          >
            <span class="offer-option__name">{{ item.offerName }}</span>
            <span class="offer-option__code">{{ item.offerNbr }}</span>
            <van-icon v-if="form.offerNbr === item.offerNbr" name="success" />
          </button>
        </div>
      </div>
    </div>

    <section class="panel">
      <div class="section-title">
        <span><van-icon name="contact" />客户信息</span>
      </div>
      <van-form>
        <van-field v-model="form.customerName" label="客户姓名" placeholder="请输入客户姓名" clearable />
        <van-field
          v-model="form.linkPhone"
          label="联系电话"
          placeholder="请输入联系电话"
          type="tel"
          maxlength="11"
          clearable
        />
        <van-field
          v-model="form.certNum"
          label="身份证号"
          placeholder="请输入身份证号"
          maxlength="18"
          clearable
        />
      </van-form>
    </section>

    <section class="panel">
      <div class="section-title">
        <span><van-icon name="location-o" />装机地址</span>
      </div>
      <van-field
        v-model="form.provinces"
        label="省份"
        placeholder="例如：山东省"
        clearable
      />
      <van-field
        v-model="form.city"
        label="地市"
        placeholder="例如：济南市"
        clearable
      />
      <van-field
        v-model="form.county"
        label="区县"
        placeholder="例如：历城区"
        clearable
      />
      <van-field
        v-model="form.receiverAddr"
        label="详细地址"
        placeholder="请输入街道、小区、门牌号"
        type="textarea"
        rows="2"
        autosize
        clearable
      />
    </section>

    <div class="notice">
      <van-icon name="info-o" />
      <span>请保持联系电话畅通，电信外呼会核实装机资源与办理意愿。</span>
    </div>

    <div class="submit-bar">
      <van-button
        block
        round
        type="info"
        :loading="submitting"
        loading-text="提交中"
        @click="handleSubmit"
      >
        立即提交办理
      </van-button>
    </div>

    <van-dialog v-model="successVisible" title="提交成功" confirm-button-text="我知道了">
      <div class="success-content">
        <van-icon name="checked" class="success-icon" />
        <p>订单已提交至山东电信平台</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { submitBroadbandOrder } from "@/api/api";
import {
  BROADBAND_OFFERS,
  createBroadbandOrderNo,
  validateBroadbandOrderForm,
  buildBroadbandSubmitPayload,
} from "./orderForm";

export default {
  name: "BroadbandOrder",
  data() {
    const defaultOffer = BROADBAND_OFFERS[0];
    return {
      offerList: BROADBAND_OFFERS,
      form: {
        customerName: "",
        linkPhone: "",
        certNum: "",
        provinces: "",
        city: "",
        county: "",
        receiverAddr: "",
        offerNbr: defaultOffer.offerNbr,
        distributionChannel: this.$route.query.distributionChannel || "",
        orderSource: this.$route.query.orderSource || "",
      },
      showOfferPicker: false,
      submitting: false,
      successVisible: false,
    };
  },
  computed: {
    selectedOffer() {
      return this.offerList.find((item) => item.offerNbr === this.form.offerNbr) || this.offerList[0];
    },
    selectedOfferText() {
      return `${this.selectedOffer.offerName}（${this.selectedOffer.offerNbr}）`;
    },
  },
  created() {
    document.title = "宽带下单";
    this.$store.commit("setUserId", this.$route.params.id);
  },
  methods: {
    onOfferConfirm(item) {
      this.form.offerNbr = item.offerNbr;
      this.showOfferPicker = false;
    },
    async handleSubmit() {
      const checkResult = validateBroadbandOrderForm(this.form);
      if (!checkResult.valid) {
        this.$toast(checkResult.message);
        return;
      }

      this.submitting = true;
      try {
        const partnerOrderNo = this.$route.query.partnerOrderNo || createBroadbandOrderNo();
        const payload = buildBroadbandSubmitPayload(this.form, partnerOrderNo);
        const res = await submitBroadbandOrder(payload);
        if (res && res.code === 200) {
          this.successVisible = true;
        } else {
          this.$toast((res && res.message) || "宽带订单提交失败");
        }
      } catch (error) {
        this.$toast("网络异常，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.broadband-order {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding: 14px 12px 68px;
  box-sizing: border-box;
  background: #f3f7fb;
  color: #182536;
}

.page-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 268px;
  background:
    radial-gradient(circle at 18% 12%, rgba(255, 255, 255, 0.55) 0 38px, transparent 39px),
    linear-gradient(160deg, #014d92 0%, #0872bd 48%, #16a085 100%);
}

.hero {
  position: relative;
  z-index: 1;
  overflow: visible;
  padding: 20px 16px 0;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.03)),
    rgba(255, 255, 255, 0.08);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 18px 34px rgba(1, 68, 122, 0.24);

  &::after {
    content: "";
    position: absolute;
    right: -48px;
    top: -34px;
    width: 152px;
    height: 152px;
    border-radius: 50%;
    border: 28px solid rgba(255, 255, 255, 0.1);
  }

  .hero__content {
    position: relative;
    z-index: 1;
  }

  .hero__topline {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
  }

  .brand-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #ffffff;
    color: #0868b0;
    font-size: 13px;
    font-weight: 800;
  }

  h1 {
    margin: 16px 0 8px;
    max-width: 260px;
    font-size: 27px;
    line-height: 34px;
    font-weight: 800;
    letter-spacing: 0;
  }

  p {
    max-width: 285px;
    margin: 0;
    font-size: 13px;
    line-height: 18px;
    opacity: 0.93;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.hero-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.16);

  span {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    opacity: 0.78;
  }

  strong {
    font-size: 16px;
  }

  .van-icon {
    font-size: 28px;
    opacity: 0.9;
  }
}

.process {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  margin: 14px -4px -22px;
  padding: 13px 12px;
  border-radius: 10px;
  background: #fff;
  color: #1f2d3d;
  box-shadow: 0 10px 24px rgba(20, 47, 74, 0.14);

  .process__item {
    display: block;
    flex: 0 0 auto;
    text-align: center;
    white-space: nowrap;

    span {
      display: block;
      margin-bottom: 4px;
      color: #0875be;
      font-size: 12px;
      font-weight: 800;
    }

    strong {
      display: block;
      white-space: nowrap;
      font-size: 11px;
      font-weight: 700;
    }
  }

  .process__line {
    flex: 1;
    height: 1px;
    min-width: 8px;
    margin: 0 4px;
    background: #d8e4ee;
  }
}

.benefits {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 34px;
}

.benefit-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 42px;
  border-radius: 8px;
  background: #ffffff;
  color: #315066;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 6px 18px rgba(23, 54, 84, 0.06);

  .van-icon {
    color: #0b78bd;
    font-size: 17px;
  }
}

.panel {
  position: relative;
  z-index: 1;
  margin-top: 10px;
  padding: 13px 12px 11px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(18, 37, 56, 0.06);
}

.offer-panel {
  margin-top: 12px;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 800;

  span {
    display: flex;
    align-items: center;
    gap: 6px;

    .van-icon {
      color: #0875be;
      font-size: 18px;
    }
  }

  em {
    max-width: 42%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-style: normal;
    font-size: 12px;
    font-weight: 500;
    color: #6c7b8f;
  }
}

.offer-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 4px 0 8px;
  padding: 12px;
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(8, 117, 190, 0.1), rgba(18, 168, 143, 0.1)),
    #f6fbff;
  border: 1px solid #e1eff8;

  .offer-label {
    display: block;
    margin-bottom: 5px;
    color: #738395;
    font-size: 12px;
  }

  strong {
    display: block;
    font-size: 15px;
    line-height: 20px;
    color: #182536;
  }

  button {
    flex: 0 0 auto;
    min-width: 58px;
    height: 30px;
    border: 0;
    border-radius: 15px;
    background: #0875be;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
  }
}

.offer-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 10px;

  span {
    min-width: 0;
    padding: 8px 4px;
    border-radius: 8px;
    background: #eef7f4;
    color: #126a5f;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
  }
}

.offer-options {
  max-height: 58vh;
  overflow-y: auto;
  padding: 10px 12px 14px;
  box-sizing: border-box;
  background: #f6f9fc;
}

.offer-option {
  position: relative;
  width: 100%;
  min-height: 50px;
  margin-bottom: 8px;
  padding: 8px 38px 8px 12px;
  border: 1px solid #e3ebf3;
  border-radius: 8px;
  background: #f9fbfd;
  text-align: left;

  .offer-option__name {
    display: block;
    color: #1d2c3c;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    word-break: break-word;
  }

  .offer-option__code {
    display: block;
    margin-top: 4px;
    color: #7a8b9d;
    font-size: 12px;
  }

  .van-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #0875be;
    font-size: 18px;
  }

  &.active {
    border-color: #0875be;
    background: #eef8ff;
    box-shadow: 0 6px 14px rgba(8, 117, 190, 0.08);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.offer-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.offer-modal__mask {
  position: absolute;
  inset: 0;
  background: rgba(10, 25, 41, 0.78);
}

.offer-modal__panel {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 50%;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  transform: translateY(-50%);
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.3);
}

.offer-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #edf1f5;

  strong {
    color: #182536;
    font-size: 17px;
    font-weight: 800;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 50%;
    background: #edf3f8;
    color: #607487;
    font-size: 16px;
  }
}

.notice {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  margin: 10px 2px 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: #eef6fc;
  font-size: 12px;
  line-height: 18px;
  color: #657487;

  .van-icon {
    margin: 2px 6px 0 0;
    color: #0875be;
  }
}

.submit-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px 14px calc(8px + constant(safe-area-inset-bottom));
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -8px 22px rgba(18, 37, 56, 0.1);
  backdrop-filter: blur(8px);

  /deep/ .van-button--info {
    border: 0;
    background: linear-gradient(135deg, #0875be 0%, #12a88f 100%);
    font-size: 16px;
    font-weight: 800;
    box-shadow: 0 8px 16px rgba(8, 117, 190, 0.24);
  }
}

.success-content {
  padding: 18px 18px 20px;
  text-align: center;

  .success-icon {
    font-size: 44px;
    color: #12b76a;
  }

  p {
    margin: 8px 0 16px;
    font-size: 15px;
    font-weight: 700;
  }

}

/deep/ .van-cell {
  padding: 10px 0;
  background: transparent;
}

/deep/ .van-cell::after {
  left: 0;
  right: 0;
  border-color: #eef1f4;
}

/deep/ .van-field__label {
  width: 76px;
  color: #354154;
  font-weight: 600;
}

/deep/ .van-field__control {
  color: #182536;
}

/deep/ .van-field__right-icon {
  color: #8da0b4;
}
</style>
